import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Statistiques de visite : signale chaque page affichée au backend, qui
// n'enregistre ni IP ni cookie. Voir la page « Statistiques » de l'admin.

// Politique de confidentialité de l'app OpenPeaks : jamais comptée
const EXCLUDED_PATHS = ['/openpeaks/privacy', '/openpeaks/privacy/'];

// Posée par le bouton « Ne pas compter mes visites » de l'admin
const IGNORE_KEY = 'stats_ignore';

const isIgnored = () => {
  try {
    return localStorage.getItem(IGNORE_KEY) === '1';
  } catch (error) {
    // Stockage bloqué (navigation privée...) : la visite est comptée
    return false;
  }
};

function PageTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  const referrerSent = useRef(false);

  useEffect(() => {
    if (pathname === lastPath.current) {
      return;
    }
    lastPath.current = pathname;
    if (EXCLUDED_PATHS.includes(pathname) || isIgnored()) {
      return;
    }

    // Le référent ne vaut que pour l'arrivée sur le site, pas pour les
    // navigations internes de l'application
    const referrer = referrerSent.current ? '' : document.referrer;
    referrerSent.current = true;

    fetch(`${process.env.REACT_APP_BACKEND_API_URL}stats/pageview/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: pathname, referrer }),
      credentials: 'omit',
    }).catch(() => {
      // Une statistique perdue ne doit jamais gêner le visiteur
    });
  }, [pathname]);

  return null;
}

export default PageTracker;
